import { gql, TypedDocumentNode } from "@apollo/client";

import { WebhooksIntegration, WebhooksIntegrationInput } from "types/generated";

type DeleteWebhookIntegrationData = {
  webhooksIntegrationDelete: Pick<WebhooksIntegration, "id"> | null;
};

type DeleteWebhookIntegrationVariables = {
  entityId: string;
  id: string;
};

export const DELETE_WEBHOOK_INTEGRATION: TypedDocumentNode<
  DeleteWebhookIntegrationData,
  DeleteWebhookIntegrationVariables
> = gql`
  mutation DeleteWebhookIntegration($entityId: ID!, $id: ID!) {
    webhooksIntegrationDelete(id: $id, stack: $entityId) {
      id
    }
  }
`;

type CreateWebhookIntegrationData = {
  webhooksIntegrationCreate: Pick<WebhooksIntegration, "id">;
};

type CreateWebhookIntegrationVariables = {
  entityId: string;
  input: WebhooksIntegrationInput;
};

export const CREATE_WEBHOOK_INTEGRATION: TypedDocumentNode<
  CreateWebhookIntegrationData,
  CreateWebhookIntegrationVariables
> = gql`
  mutation CreateWebhookIntegration($entityId: ID!, $input: WebhooksIntegrationInput!) {
    webhooksIntegrationCreate(stack: $entityId, input: $input) {
      id
    }
  }
`;

type UpdateWebhookIntegrationData = {
  webhooksIntegrationUpdate: Pick<WebhooksIntegration, "id">;
};

type UpdateWebhookIntegrationVariables = {
  id: string;
  entityId: string;
  input: WebhooksIntegrationInput;
};

export const UPDATE_WEBHOOK_INTEGRATION: TypedDocumentNode<
  UpdateWebhookIntegrationData,
  UpdateWebhookIntegrationVariables
> = gql`
  mutation UpdateWebhookIntegration($id: ID!, $entityId: ID!, $input: WebhooksIntegrationInput!) {
    webhooksIntegrationUpdate(id: $id, stack: $entityId, input: $input) {
      id
    }
  }
`;
